import { useEffect } from 'react';

const useHandleClickOutside = (ref, fn, opts = {}) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        fn(event);
      }
    };
    // Bind the event listener
    document.addEventListener(opts.event || 'mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener(opts.event || 'mousedown', handleClickOutside);
    };
  }, [ref]);
};
export { useHandleClickOutside };
